////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const salesHistoryByCodes = {
	[ActionsTypes.GET_HISTO_CODE]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_HISTO_CODE_SUCCESS]: (state, payload) => {
		let paginedData = payload.data.headerContent.contentPagined
		let payloadFiltersCp = cloneDeep(payload.data.headerParam.filters)
		let items = payload.data.headerContent.contentPagined.content

		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				paging: {
					$set: paginedData,
				},
				items: {
					$set: items,
				},
				header: {
					$set: payloadFiltersCp,
				},
			},
		})
	},
	[ActionsTypes.GET_HISTO_CODE_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_DISPLAY_TICKET]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.POST_DISPLAY_TICKET_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)

		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				data: {
					$set: data,
				},
			},
		})
	},

	[ActionsTypes.POST_DISPLAY_TICKET_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.GET_TRANSACTION_ID]: (state, payload) => {
		let transactionNumber = payload.salesByCodes

		return update(state, {
			salesHistoryManager: {
				transactionNumber: {
					$set: transactionNumber,
				},
			},
		})
	},

	[ActionsTypes.POST_REVIEW_TICKET]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.POST_REVIEW_TICKET_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		let numberSms = cloneDeep(payload.data.numberSMSAvailable)
		let optionSms = data.optionSMS

		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				data: {
					$set: data,
				},
				sms: {
					$set: numberSms,
				},
				optionSms: {
					$set: optionSms,
				},
			},
		})
	},

	[ActionsTypes.POST_REVIEW_TICKET_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_SMS_TICKET]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.POST_SMS_TICKET_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)

		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				data: {
					$set: data,
				},
			},
		})
	},

	[ActionsTypes.POST_SMS_TICKET_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_DELETE_SALE_CODE]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.POST_DELETE_SALE_CODE_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.salesHistoryByCodes.paging.content)
		const idx = findIndex(stateCp, { salesOrderId: data.salesOrderId })
		stateCp[idx] = data
		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: stateCp,
				},
			},
		})
	},

	[ActionsTypes.POST_DELETE_SALE_CODE_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_CANCEL_SALE_CODE]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.POST_CANCEL_SALE_CODE_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.salesHistoryByCodes.paging.content)
		const idx = findIndex(stateCp, { salesOrderId: data.salesOrderId })
		stateCp[idx] = data
		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: stateCp,
				},
			},
		})
	},

	[ActionsTypes.POST_CANCEL_SALE_CODE_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.POST_RENEW_CODE]: (state) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: true,
				},
			},
		}),

	[ActionsTypes.POST_RENEW_CODE_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.salesHistoryByCodes.paging.content)
		const idx = findIndex(stateCp, { salesOrderId: data.salesOrderId })
		stateCp[idx] = data
		return update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: stateCp,
				},
			},
		})
	},

	[ActionsTypes.POST_RENEW_CODE_FAILURE]: (state, payload) =>
		update(state, {
			salesHistoryByCodes: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_HISTO_CODE_ITEMS]: (state, _payload) => {
		return update(state, {
			salesHistoryByCodes: {
				items: {
					$set: [],
				},
				itemCatalog: {
					$set: {},
				},
				header: {
					$set: {},
				},
			},
		})
	},
}

export default salesHistoryByCodes
